import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ selectedWarehouse, handleClose, notification, refreshList, editWarehouse, warehouseId }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;

  const formModel = {
    name: selectedWarehouse,
    organizationId: orgId,
    longitude: '',
    latitude: '',
    length: null,
    width: null,
    attributes: null,
    createdBy: userId,
  };

  const [attributes, setAttributes] = useState({});
  const [floorMap, setFloorMap] = useState('');
  const [dropdown, setDropdown] = useState('MERAKI');
  const [configFile, setConfigFile] = useState();
  const [siteId, setSiteId] = useState('');
  const [token, setToken] = useState('');

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [warehouseData, getWarehouseData] = useApi();
  const [floormapState, uploadFloormap] = useApi();
  const [uploadConfigRes, uploadConfig] = useApi();

  const fileRef = useRef();
  const key = useRef(null);
  const value = useRef(null);
  const configRef = useRef();

  const handleChange = (e) => {
    const fileType = ['image/jpeg', 'image/png', 'image/svg+xml'];
    const [file] = e.target.files;
    if (file) {
      if (file && fileType.includes(file.type)) {
        setFloorMap(file);
      }
    }
  };

  useEffect(() => {
    if (editWarehouse) {
      getWarehouseData(`/warehouse/${warehouseId}`, 'GET');
    }
  }, []);

  useEffect(() => {
    if (!warehouseData.isLoading && !warehouseData.isError && warehouseData.data) {
      console.log(warehouseData);
      setFormData({
        name: warehouseData.data?.warehouse.name,
        organizationId: warehouseData.data?.warehouse?.organizationId,
        longitude: warehouseData.data?.warehouse?.Address?.longitude,
        latitude: warehouseData.data?.warehouse?.Address?.latitude,
        length:
          warehouseData.data?.warehouse?.attributes && warehouseData.data?.warehouse?.attributes?.rtls === 'QUUPPA'
            ? ''
            : warehouseData.data?.warehouse?.attributes?.length,
        width:
          warehouseData.data?.warehouse?.attributes && warehouseData.data?.warehouse?.attributes?.rtls === 'QUUPPA'
            ? ''
            : warehouseData.data?.warehouse?.attributes?.width,
        attributes: null,
        createdBy: warehouseData.data?.warehouse.createdBy,
      });

      setDropdown(warehouseData.data?.warehouse.attributes && warehouseData.data?.warehouse.attributes?.rtls);
      setToken(warehouseData.data?.warehouse.attributes && warehouseData.data?.warehouse.attributes?.token);
      setSiteId(warehouseData.data?.warehouse.attributes && warehouseData.data?.warehouse.attributes?.siteId);
    }
  }, [warehouseData]);

  const handleInputChange = useCallback((e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { width, length } = formData;

    if (dropdown === 'MIST') {
      attributes.siteId = siteId;
      attributes.token = token;
    } else if (dropdown !== 'QUUPPA') {
      attributes.length = parseFloat(length);
      attributes.width = parseFloat(width);
    }

    attributes.rtls = dropdown;

    const body = {
      ...formData,
      attributes,
    };
    console.log(body);
    if (editWarehouse) {
      postData(`/warehouse/${warehouseId}`, 'PATCH', body);
    } else {
      postData(`/warehouse`, 'POST', body);
    }
  };

  const handleAddAttributes = () => {
    const x = { ...attributes };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setAttributes(x);
  };

  const deleteAttribute = (item) => {
    const attr = { ...attributes };
    delete attr[item[0]];

    setAttributes(attr);
  };

  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [attributes]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      editWarehouse
        ? notification('success', `Warehouse updated successfully`)
        : notification('success', `Warehouse Created successfully`);
      const _id = data.id || warehouseId;
      if (floorMap) {
        const x = new FormData();
        x.append('file', floorMap, floorMap.name);
        uploadFloormap(`/warehouse/${_id}/floorPlan`, 'POST', x);
      } else if (configFile) {
        const x = new FormData();
        x.append('file', configFile);
        uploadConfig(`/warehouse/${_id}/rtlsConfig`, 'POST', x);
      } else {
        handleClose();
        refreshList();
      }
    }
    if (isError) {
      notification('error', data);
      refreshList();
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!floormapState.isLoading && !floormapState.isError && floormapState.data) {
      handleClose();
    }
  }, [floormapState]);

  useEffect(() => {
    if (!uploadConfigRes.isLoading && !uploadConfigRes.isError && uploadConfigRes.data) {
      handleClose();
    }
  }, [uploadConfigRes]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 left-0 right-0 bottom-0 top-0 "
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4  pt-1 relative rounded-2xl mobile_toggle">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-6 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pl-6">
          {editWarehouse ? 'Edit Warehouse' : 'Create Warehouse'}
        </p>
        {/* <p className="font-bold text-lg text-textBlue1">CREATE GATEWAY</p> */}
        <form className="mt-2 mb-2 mx-10 flex flex-wrap " onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-2.25/5 relative ">
            <input
              type="text"
              placeHolder="Warehouse Name"
              value={formData.name}
              autoComplete="off"
              name="name"
              className="inputLabelText px-4 py-2 focus:outline-none back-dim "
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            <select
              className="inputLabelText font-normal text-black px-4 py-2 focus:outline-none"
              value={dropdown}
              onChange={(e) => setDropdown(e.target.value)}
            >
              <option>MERAKI</option>
              <option>QUUPPA</option>
              <option>Tag-N-Trac</option>
              <option>MIST</option>
            </select>
          </div>
          {dropdown === 'MIST' ? (
            <>
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LATITUDE
            </label> */}
                <input
                  type="text"
                  placeholder="Site Id"
                  value={siteId}
                  name="latitude"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(e) => setSiteId(e.target.value)}
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LONGITUDE
            </label> */}
                <input
                  type="text"
                  placeholder="Token"
                  value={token}
                  name="longitude"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(e) => setToken(e.target.value)}
                />
              </div>
            </>
          ) : (
            <>
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LATITUDE
            </label> */}
                <input
                  type="text"
                  placeholder="Latitude"
                  value={formData.latitude}
                  name="latitude"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LONGITUDE
            </label> */}
                <input
                  type="text"
                  placeholder="Longitude"
                  value={formData.longitude}
                  name="longitude"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
            </>
          )}

          {dropdown === 'MERAKI' ? (
            <>
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LATITUDE
            </label> */}
                <input
                  type="text"
                  placeholder={'Length'}
                  value={formData.length}
                  name="length"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-5 w-2.25/5 relative">
                {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LONGITUDE
            </label> */}
                <input
                  type="text"
                  placeholder={'Width'}
                  value={formData.width}
                  name="width"
                  autoComplete="off"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
            </>
          ) : (
            dropdown === 'QUUPPA' &&
            (!editWarehouse || (editWarehouse && !warehouseData.data.warehouse.attributes)) && (
              <>
                <input
                  ref={configRef}
                  onChange={(e) => {
                    setConfigFile(e.target.files[0]);
                  }}
                  multiple={false}
                  type="file"
                  hidden
                />
                <div
                  className="mt-4 w-2.25/5 text-center py-2 rounded-md bg-primary text-white cursor-pointer"
                  onClick={() => configRef.current.click()}
                >
                  Upload Config File
                </div>
              </>
            )
          )}

          <p className="mt-5 w-full text-xs font-bold">ATTRIBUTES</p>

          <div className="relative flex w-full">
            <div className="mt-5 w-2.25/5">
              {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
                KEY
              </label> */}
              <input type="text" ref={key} placeHolder="Key" className="inputLabelText px-4 py-2 focus:outline-none" />
            </div>

            <div className="w-1/10" />
            <div className="mt-5 w-2.25/5">
              {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
                VALUE
              </label> */}
              <input
                type="text"
                ref={value}
                placeHolder="Value"
                className="inputLabelText px-4 py-2 focus:outline-none"
              />
            </div>

            <img
              src="assets/img/Add.svg"
              className="absolute -right-8 h-6 top-7 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>

          <div className="w-full flex mt-4 ">
            {attributes &&
              Object.entries(attributes)
                .filter((x) => x[0] !== 'siteId' && x[0] !== 'token')
                .map((item) => (
                  <p
                    className="relative text-black py-1 px-4 rounded-full border mr-2 cursor-pointer "
                    onClick={() => deleteAttribute(item)}
                  >
                    {item.join(' - ')}
                    <img src="assets/img/Close.svg" className="h-2 absolute top-0 -right-1 cursor-pointer" alt="" />
                  </p>
                ))}
          </div>

          {/* <div className="inputLabelText px-4 py-2 mt-6 h-32 w-full"></div> */}
          {dropdown !== 'Tag-N-Trac' && (
            <div className="w-2.25/5 relative">
              <div className="items-center">
                <div
                  className="mt-4 text-center py-2 rounded-md bg-primary w-full text-white cursor-pointer"
                  onClick={() => fileRef.current.click()}
                >
                  Upload Floor Map
                </div>
                <span
                  className={`mt-5 mr-2 ml-2 text-xs p-2 block ${
                    floorMap !== null && floorMap.name ? 'border rounded-tl-lg rounded-br-lg rounded-bl-lg' : ''
                  }  relative truncate`}
                  style={{ maxWidth: '200px' }}
                >
                  {floorMap !== null ? floorMap.name : ''}
                  {floorMap !== null && floorMap.name ? (
                    <img
                      src="assets/img/Close.svg"
                      className="absolute top-1 right-2 h-2 cursor-pointer"
                      alt=""
                      onClick={() => setFloorMap(null)}
                    />
                  ) : null}
                </span>
                <input ref={fileRef} onChange={handleChange} multiple={false} type="file" accept="image/*" hidden />
                {floormapState.isLoading && (
                  <img src="assets/img/loader.svg" className="w-16 transform translate-y-3" alt="" />
                )}
              </div>
            </div>
          )}
          <div className="w-1/10" />
          <div className="w-2.25/5 mt-5 mb-2 relative ml-auto">
            {isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl w-1/2  border focus:outline-none  h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl w-1/2 focus:outline-none h-10 text-white bg-primary cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default index;
